var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "text-center mb-6" }, [
      _vm._v(_vm._s(_vm.$t("roomWizard.success")))
    ]),
    _c(
      "div",
      { staticClass: "text-center text-h6 mb-8" },
      [
        _c("va-icon", {
          staticClass: "mb-6",
          attrs: { icon: "vi vi-c-check", color: "success", size: "l" }
        }),
        _c("div", {}, [
          _vm._v(_vm._s(_vm.$t("roomWizard.successDescription")))
        ]),
        _c("div", { staticClass: "mb-6" }, [
          _vm._v(_vm._s(_vm.$t("roomWizard.moreWithPolicies")))
        ]),
        _c("router-link", { attrs: { to: "/rooms" } }, [
          _vm._v(_vm._s(_vm.$t("roomWizard.backToRooms")))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }